const indexRouter = {
    path: 'datas',
    name: 'datas',
    meta: {
        title: '数据'
    },
    redirect: {
        name: 'mydata'
    },
    component: () => import('@/components/router/Router'),
    children:[
        {
            path: "mydata",
            name: "mydata",
            meta: {
                title: "我的数据"
            },
            redirect: {
                name: 'datalist'
            },
            component: () => import("@/pages/datas/mydata/Index"),
            children:[
                {
                    path: "datalist",
                    name: "datalist",
                    meta: {
                        title: "数据列表"
                    },
                    component: () => import("@/pages/datas/mydata/data_list/DataList")
                },
                {
                    path: "remarklist",
                    name: "remarklist",
                    meta: {
                        title: "备注列表"
                    },
                    component: () => import("@/pages/datas/mydata/remark_list/RemarkList")
                }
            ]
        },
        {
            path: "overalldata",
            name: "overalldata",
            meta: {
                title: "全局数据"
            },
            redirect: {
                name: 'overall_data'
            },
            component: () => import("@/pages/datas/overalldata/Index"),
            children : [
                {
                    path: "overall_data",
                    name: "overall_data",
                    meta: {
                        title: "数据列表"
                    },
                    component: () => import("@/pages/datas/overalldata/data_list/DataList")
                },
            ],
        },
        {
            path: "subscribedata",
            name: "subscribedata",
            meta: {
                title: "订阅数据"
            },
            redirect: {
                name: 'order_data'
            },
            component: () => import('@/components/router/Router'),
            children : [
                {
                    path: "order_data",
                    name: "order_data",
                    meta: {
                        title: "订阅数据"
                    },
                    component: () => import("@/pages/datas/subscribedata/Index")
                },
                {
                    path: "other_data",
                    name: "other_data",
                    meta: {
                        title: "订阅数据"
                    },
                    component: () => import("@/pages/datas/subscribedata/Other"),
                    children:[
                        {
                            path: "datalist",
                            name: "other_datalist",
                            meta: {
                                title: "数据列表"
                            },
                            component: () => import("@/pages/datas/mydata/data_list/DataList")
                        },
                        {
                            path: "remarklist",
                            name: "other_remarklist",
                            meta: {
                                title: "备注列表"
                            },
                            component: () => import("@/pages/datas/mydata/remark_list/RemarkList")
                        }
                    ]
                },
            ],
            
        },
    ]
};
export default indexRouter;


// WEBPACK FOOTER //
// ./src/router/datas/indexRouter.js